import Theme from "../../constants/Theme";
import styled from "styled-components/macro";
import Typography from "../../atoms/typography";
import { DPIconMail, DPIconCircleRightArrow } from "../../assets/icons";
import Button from "../../atoms/Button";
import media from "../../constants/MediaQuery";
import { useHistory } from "react-router-dom";

const Contact = () => {
  const history = useHistory();
  return (
    <CS>
      <div className="Contact__CS__cs-container container">
        <div className="Contact__CS__">
          <Typography.Heading
            className="Contact__CS__contact-title"
            color="darkBlue"
            weight="semiBold"
            level={3}
            uppercase
            fontType="Galano"
            style={{
              letterSpacing: "0.25em",
            }}
          >
            Contact
          </Typography.Heading>
          <div className="Contact__CS__cs-container--mail-container">
            <DPIconMail className="mail" />
            <Typography.Text fontType="Galano">
              hello@dotpay.africa
            </Typography.Text>
          </div>
        </div>
        <Button
          className="landing-btn"
          primary
          onClick={() => history.push("/contact-us")}
        >
          <Typography.Text uppercase weight="semiBold" level="xlarge">
            Send message
          </Typography.Text>
          <DPIconCircleRightArrow />
        </Button>
      </div>
    </CS>
  );
};
const CS = styled.div`
background: linear-gradient(#fbfbfb, #e4ffe1);
  display: flex;
  padding: 50px 0;
  .Contact__CS{
    background: yellow;
    &__contact-title {
      margin-bottom: 10px;
      font-size: calc(${Theme.fontSizes.xlarge} - 30%);
    }
    &__cs-container {
      display: flex;
      flex-direction: column;
      ${media.tabletMin`
       flex-direction: column;
       justify-content: space-between;
       align-items:center;
     `};
     ${media.smallDesktopMin`
       flex-direction: row;
       justify-content: space-between;
       align-items:center;
     `};
     &--mail-container{
      display:  flex;
      align-items: center;
      >p {
     margin-left: 30px;
     font-size: ${Theme.fontSizes.xxxlarge};
     font-weight: ${Theme.fontWeights.normal};
     @media screen and (max-width: 768px) {
        font-size: ${Theme.fontSizes.xlarge};
      }
     }
    }
    }
  }
}
`;

export default Contact;
